export const LOCAL_STORAGE_LAST_SEARCHES_KEY = 'LAST_SEARCHES';
export const LAST_SEARCHES_QUANTITY = 3;
